var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":"","icon":"","large":""},on:{"click":function($event){return _vm.handleClipBoard(_vm.$props.text)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-content-copy")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.hoverText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }